'use client';

import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * On every route change, scrolls the window to the top of the page and
 * moves keyboard focus to the <main id="main"> element so screen readers
 * announce the new page. Skips the very first render so a deep-link with
 * a hash (#contacto, etc.) keeps the browser's native anchor scroll.
 */
export function ScrollToTop() {
  const { pathname, search } = useLocation();
  const isFirst = useRef(true);

  useEffect(() => {
    if (isFirst.current) {
      isFirst.current = false;
      return;
    }
    if (typeof window !== 'undefined' && window.location.hash) return;

    window.scrollTo({ top: 0, left: 0, behavior: 'instant' as ScrollBehavior });

    const main = document.getElementById('main');
    if (main) {
      main.focus({ preventScroll: true });
    }
  }, [pathname, search]);

  return null;
}
